import React from 'react';

function getStatusText(order) {
    switch (order.orderStatus) {
        case 'delivered':
            return 'Delivered';
        case 'cancelled':
            return 'Cancelled';
        case 'returned':
            return 'Returned';
    }
}

export function DeliveryStatus({ order, className }) {    
    return (<span className={className}>
        <img src={`./side_${order.orderStatus}.svg`}/>
        <span>{getStatusText(order)}</span>
    </span>);
}


// WEBPACK FOOTER //
// ./src/components/sidebarOrders/order/DeliveryStatus.js